export const isOfflineMode = (): boolean => {
  if (!window) {
    // If window object does not exist we are not in a browser environment as such we are offline.
    return true;
  }
  return window.env.E2E === "true";
};
